module.exports = __webpack_public_path__ + "static/media/flexibag.c8dd7f2c.jpg";